export const CHART_COLORS = {
  primary: '#5895E9',
  bluishGray: '#4e5983',
  highlight: '#9DC0F2',  
  gray: '#707070',   
  warning: '#FF4343', 
};

export const ROLE_PALETTE = [
  '#5895E9', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948',
];

export const OTHER_ROLE_NAME = 'Other';

export const OTHER_SLICE_COLOR = CHART_COLORS.gray;


export const getRoleSliceColor = (roleName, index) =>
  roleName === OTHER_ROLE_NAME ? OTHER_SLICE_COLOR : ROLE_PALETTE[index % ROLE_PALETTE.length];
